import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles({
    spinner: {
        animation: 'spin 2s linear infinite',
        animationIterationCount: 'infinite',
    },
})

const SpinnerIcon = (props) => {
    const { size, style } = props

    const classes = useStyles()

    return (
        <svg
            className={classes.spinner}
            style={style}
            width={size || 21}
            height={size || 22}
            viewBox="0 0 21 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.45801 1.62504C9.45801 1.049 9.92467 0.583374 10.4997 0.583374C11.0747 0.583374 11.5413 1.049 11.5413 1.62504V3.70837C11.5413 4.28442 11.0747 4.75004 10.4997 4.75004C9.92467 4.75004 9.45801 4.28442 9.45801 3.70837V1.62504ZM17.7913 9.95837H19.8747C20.4497 9.95837 20.9163 10.424 20.9163 11C20.9163 11.5761 20.4497 12.0417 19.8747 12.0417H17.7913C17.2163 12.0417 16.7497 11.5761 16.7497 11C16.7497 10.424 17.2163 9.95837 17.7913 9.95837ZM4.24967 11C4.24967 10.424 3.78301 9.95837 3.20801 9.95837H1.12467C0.549675 9.95837 0.0830078 10.424 0.0830078 11C0.0830078 11.5761 0.549675 12.0417 1.12467 12.0417H3.20801C3.78301 12.0417 4.24967 11.5761 4.24967 11ZM3.00665 3.7639C3.4077 3.3514 4.06603 3.33785 4.47957 3.73785L5.97853 5.18577C6.39207 5.58473 6.40353 6.24515 6.00353 6.65869C5.79936 6.87015 5.52749 6.9764 5.25457 6.9764C4.99415 6.9764 4.73374 6.88056 4.53061 6.68473L3.03165 5.23681C2.61811 4.83785 2.60665 4.17744 3.00665 3.7639ZM15.7447 6.97681C16.0051 6.97681 16.2655 6.87994 16.4686 6.68515L17.9676 5.23723C18.3811 4.83723 18.3926 4.17681 17.9926 3.76431C17.5936 3.35181 16.9353 3.33827 16.5197 3.73827L15.0207 5.18515C14.6072 5.58515 14.5957 6.24556 14.9957 6.65806C15.1999 6.86952 15.4718 6.97681 15.7447 6.97681ZM9.45801 18.2917C9.45801 17.7157 9.92467 17.25 10.4997 17.25C11.0747 17.25 11.5413 17.7157 11.5413 18.2917V20.375C11.5413 20.9511 11.0747 21.4167 10.4997 21.4167C9.92467 21.4167 9.45801 20.9511 9.45801 20.375V18.2917ZM16.4684 15.3152C16.0549 14.9163 15.3955 14.9288 14.9955 15.3413C14.5955 15.7548 14.607 16.4152 15.0205 16.8142L16.5195 18.2621C16.7226 18.458 16.983 18.5538 17.2434 18.5538C17.5163 18.5538 17.7882 18.4475 17.9924 18.2361C18.3924 17.8225 18.3809 17.1621 17.9674 16.7632L16.4684 15.3152ZM3.03197 16.7632L4.53092 15.3152C4.94551 14.9163 5.60488 14.9288 6.00384 15.3413C6.40384 15.7548 6.39238 16.4152 5.97884 16.8142L4.47988 18.2621C4.27676 18.458 4.01634 18.5538 3.75592 18.5538C3.48301 18.5538 3.21113 18.4475 3.00697 18.2361C2.60697 17.8225 2.61842 17.1621 3.03197 16.7632Z"
                fill="#303E4E"
            />
        </svg>
    )
}
export default SpinnerIcon
